// Polyfill btoa and atob for Jest environment
const btoaPolyfill = (str: string) => Buffer.from(str, 'binary').toString('base64');
const atobPolyfill = (str: string) => Buffer.from(str, 'base64').toString('binary');

// Set up on globalThis
Object.defineProperty(globalThis, 'btoa', {
  value: btoaPolyfill,
  writable: true,
  configurable: true,
});

Object.defineProperty(globalThis, 'atob', {
  value: atobPolyfill,
  writable: true,
  configurable: true,
});

// Set up on window if it exists
if (typeof globalThis.window !== 'undefined') {
  Object.defineProperty(globalThis.window, 'btoa', {
    value: btoaPolyfill,
    writable: true,
    configurable: true,
  });

  Object.defineProperty(globalThis.window, 'atob', {
    value: atobPolyfill,
    writable: true,
    configurable: true,
  });
} else {
  // Create window object and attach to globalThis
  const mockWindow = {
    btoa: btoaPolyfill,
    atob: atobPolyfill,
  };

  Object.defineProperty(globalThis, 'window', {
    value: mockWindow,
    writable: true,
    configurable: true,
  });
}

if (typeof global !== 'undefined') {
  Object.defineProperty(global, 'btoa', {
    value: btoaPolyfill,
    writable: true,
    configurable: true,
  });

  Object.defineProperty(global, 'atob', {
    value: atobPolyfill,
    writable: true,
    configurable: true,
  });

  if (typeof global.window !== 'undefined') {
    Object.defineProperty(global.window, 'btoa', {
      value: btoaPolyfill,
      writable: true,
      configurable: true,
    });

    Object.defineProperty(global.window, 'atob', {
      value: atobPolyfill,
      writable: true,
      configurable: true,
    });
  } else {
    Object.defineProperty(global, 'window', {
      value: {
        btoa: btoaPolyfill,
        atob: atobPolyfill,
      },
      writable: true,
      configurable: true,
    });
  }
}

// Suppress console logs in CI/CD environment
const isCI = !!process.env.IS_CI || !!process.env.CI;

if (isCI) {
  // Override console methods to suppress output in CI
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}

if (!isCI) {
  console.log('[jest.setup.ts] btoa/atob polyfills configured');
}
